type Handler = () => void;
type EventHandlerMap<TEvent extends string> = Record<TEvent, Handler[]>;

export default class EventEmitter<TEvent extends string> {
  private eventHandlerMap: Partial<EventHandlerMap<TEvent>> = {};

  private getOrCreateHandlers(event: TEvent): Handler[] {
    const current: undefined | Handler[] = this.eventHandlerMap[event];

    if (current) {
      return current;
    }

    const handlers: Handler[] = [];
    this.eventHandlerMap[event] = handlers;
    return handlers;
  }

  public on(event: TEvent, handler: Handler) {
    if (!handler) {
      return;
    }

    const handlers = this.getOrCreateHandlers(event);
    if (handlers.includes(handler)) {
      return;
    }

    handlers.push(handler);
  }

  public off(event: TEvent, handler: Handler) {
    const current = this.eventHandlerMap[event];

    if (!current) {
      return;
    }

    const index = current.indexOf(handler);
    current.splice(index, 1);

    if (current.length === 0) {
      this.eventHandlerMap[event] = undefined;
    }
  }

  public emit(event: TEvent) {
    const handlers = this.eventHandlerMap[event];

    if (handlers) {
      handlers.forEach((handler) => handler());
    }
  }
}
